import { useFeatureGate } from '@statsig/react-bindings';

import { telehealthIntroRoomRedesignGate } from '../../../statsig/gates';
import { MinimalPageContentWrapper as MinimalPageContent } from './MinimalPageContent';
import { NewIntroRoomContentWrapper as NewIntroRoomContent } from './NewIntroRoomContent';

export function PageContent() {
  const { value: isIntroRoomRedesignEnabled } = useFeatureGate(telehealthIntroRoomRedesignGate);

  if (isIntroRoomRedesignEnabled) {
    return <NewIntroRoomContent />;
  }

  return <MinimalPageContent />;
}
